import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/list.actions';
import * as home from '../../../../actions/process.home.actions';

import Hidden from '@material-ui/core/Hidden';

import Loading from '../../../dialogs/loading';
import Menu from '../Menu';
import Catalog from './Catalog';
import Error from '../../../dialogs/Error';

class Catalogs extends React.Component {
    state = {
        hide: false,
        open: undefined,
    };

    constructor(props) {
        super(props);
        props.load(props.id);
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleBack = () => {
        /*
            let path = this.props.history.location.pathname.split('/');
            path.splice(path.length - 1, 1);
            path = path.join('/');
            this.props.history.push(path);
            */
           if(this.props.lastLocation && this.props.lastLocation.pathname === "/user/login") {
            this.props.history.push("/");
        } else {
            this.props.history.goBack();
        }  
    };

    render() {
        const { info, list, list_is_loading } = this.props;
        if (
            info &&
            info.security &&
            info.security.totalPermits &&
            !(info.security.totalPermits.some((f) => f === '67' || f === '59' || f === '20') &&
              info.security.licencias.some((f) => f.id === 154 && f.activo))
        ) {
            return <Error open id={'unauthorized_access'} handleClose={this.handleBack} />;
        } else {
            return (
                <div className={'flex_full_row bg_ice_blue'}>
                    {list === undefined && list_is_loading && <Loading open opacity />}
                    <Hidden xsDown>
                        <div
                            className={
                                'flex_20 overflow_y_scroll padding_top_12 shadow_right_on_tablet bg_white'
                            }
                            onScroll={this.handleScroll}
                        >
                            <Menu code={3} />
                        </div>
                    </Hidden>
                    <div className={'flex_full_row'}>
                        <div
                            className={'flex_full overflow_y_scroll height100 bg_ice_blue showbar'}
                            onScroll={this.handleScroll}
                        >
                            <Catalog id={this.props.id} />
                        </div>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        list_is_loading: state.list_is_loading,
        list: state.list,
        info: state.info,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, home), dispatch);
};

Catalogs = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Catalogs);

Catalogs = withRouter(Catalogs);

export default Catalogs;



// WEBPACK FOOTER //
// ./src/components/complex/inventory/catalog/Index.js